<template>
  <div class="transaction-data">
    <div class="container">
      <!-- 标签页 -->
      <div class="tabs">
        <!-- <div class="tab-item">生产数据</div> -->
        <div class="tab-item active">销售数据</div>
        <!-- <div class="tab-item">分销数据</div> -->
      </div>

      <!-- 销售数据概览 -->
      <div class="card">
        <h3 class="card-title">销售数据概况(当天)</h3>
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-value">0</div>
            <div class="stat-change"><span class="down">↓</span> 0%</div>
            <div class="stat-label">销售额</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">0</div>
            <div class="stat-change"><span class="down">↓</span> 0%</div>
            <div class="stat-label">订单数</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">0</div>
            <div class="stat-change"><span class="down">↓</span> 0%</div>
            <div class="stat-label">订单成交率</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">0</div>
            <div class="stat-change"><span class="down">↓</span> 0%</div>
            <div class="stat-label">新客数量</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">0</div>
            <div class="stat-label">退货单</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">0</div>
            <div class="stat-label">退货金额</div>
          </div>
        </div>
      </div>

      <!-- 销售额趋势 -->
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">销售额趋势</h3>
          <div class="time-selector">
            <div
              class="time-item"
              :class="{ active: timeRange === 7 }"
              @click="changeTimeRange(7)"
            >
              7天
            </div>
            <div
              class="time-item"
              :class="{ active: timeRange === 30 }"
              @click="changeTimeRange(30)"
            >
              30天
            </div>
          </div>
        </div>
        <div class="chart-container">
          <div ref="salesChart" class="chart" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { api_sumOrderChatBank } from '@/api/index';

export default {
  name: 'TransactionData',
  data() {
    return {
      salesChart: null,
      timeRange: 7, // 默认7天
      chartData: {
        dates: [],
        sales: [],
        refunds: []
      }
    };
  },
  mounted() {
    this.getSalesData();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 获取销售数据
    async getSalesData() {
      try {
        const params = {
          days: this.timeRange
        };
        const res = await api_sumOrderChatBank(params);
        if (res && res.data) {
          this.chartData = res.data;
          this.initSalesChart();
        }
      } catch (error) {
        console.error('获取销售数据失败:', error);
        // 使用模拟数据
        this.chartData = {
          dates: ['2025-11-25', '2025-11-26', '2025-11-27'],
          sales: [0, 0, 60],
          refunds: [0, 0, 0]
        };
        this.initSalesChart();
      }
    },
    // 初始化销售图表
    initSalesChart() {
      if (!this.salesChart) {
        this.salesChart = echarts.init(this.$refs.salesChart);
      }
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['销售额', '退款额'],
          bottom: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          top: '3%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.chartData.dates
        },
        yAxis: {
          type: 'value',
          min: 0
        },
        series: [
          {
            name: '销售额',
            type: 'line',
            data: this.chartData.sales,
            smooth: true,
            lineStyle: {
              color: '#5470c6'
            }
          },
          {
            name: '退款额',
            type: 'line',
            data: this.chartData.refunds,
            smooth: true,
            lineStyle: {
              color: '#ee6666'
            }
          }
        ]
      };
      this.salesChart.setOption(option);
    },
    // 切换时间范围
    changeTimeRange(range) {
      this.timeRange = range;
      this.getSalesData();
    },
    // 处理窗口大小变化
    handleResize() {
      if (this.salesChart) {
        this.salesChart.resize();
      }
    }
  }
};
</script>

<style scoped>
.transaction-data {
  padding: 0 0;
}

.transaction-data h2 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* 标签页样式 */
.tabs {
  display: flex;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tab-item {
  flex: 1;
  padding: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  color: #666;
}

.tab-item.active {
  background-color: #ff7f50;
  color: #fff;
}

/* 卡片样式 */
.card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

/* 统计数据网格 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
}

.stat-item {
  text-align: center;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #5470c6;
  margin-bottom: 5px;
}

.stat-change {
  font-size: 12px;
  margin-bottom: 5px;
}

.stat-change .down {
  color: #ee6666;
}

.stat-label {
  font-size: 12px;
  color: #666;
}

/* 时间选择器 */
.time-selector {
  display: flex;
  gap: 10px;
}

.time-item {
  padding: 6px 12px;
  background-color: #f0f0f0;
  border-radius: 15px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.time-item.active {
  background-color: #5470c6;
  color: #fff;
}

/* 图表容器 */
.chart-container {
  width: 100%;
  height: 300px;
}

.chart {
  width: 100%;
  height: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    padding: 0;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .stat-item {
    padding: 10px;
  }

  .stat-value {
    font-size: 20px;
  }

  .card {
    padding: 15px;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .chart-container {
    height: 250px;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .chart-container {
    height: 200px;
  }
}
</style>
